import React from 'react';

const Faq = ({ serviceDetails }) => {

    const { faq } = serviceDetails
    console.log("from faq", serviceDetails);

    return (
        <div>
            <h1 className='text-2xl font-semibold mb-10'>FAQ</h1>
            <div>
                {
                    faq ? faq.map(fq => <div key={fq.id} tabIndex={fq?.id} className="collapse my-2 collapse-arrow border border-base-500 bg-base-100 ">
                        <div className="collapse-title text-xl font-medium">
                            {fq?.question}
                        </div>
                        <div className="collapse-content">
                            <p tabIndex={fq?.id} className='text-lg'> {fq?.answer}</p>
                        </div>
                    </div>) : ''
                }



                {/*      <div tabIndex={1} className="collapse my-2 collapse-arrow border border-base-500 bg-base-100 ">
                    <div className="collapse-title text-xl font-medium">
                        Will you provide domain and hosting services?
                    </div>
                    <div className="collapse-content">
                        <p tabIndex={1} className='text-lg'> No, I dont provide hosting/domain name registration services. In order to have full control over the website, I highly recommend you purchase these yourself in your ID & Payment. So that no body even me, can have a back hole to penetrate in to the website even after years. I recommend Bluehost.</p>
                    </div>
                </div>

                <div tabIndex={2} className="collapse my-2 collapse-arrow border border-base-500 bg-base-100 ">
                    <div className="collapse-title text-xl font-medium">
                        Can i add courses my self?
                    </div>
                    <div className="collapse-content">
                        <p tabIndex={2} className='text-lg'> Yes, you will be able to add courses easily. If you don't know about how to add course then i will teach by screensharing.</p>
                    </div>
                </div>

                <div tabIndex={3} className="collapse my-2 collapse-arrow border border-base-500 bg-base-100 ">
                    <div className="collapse-title text-xl font-medium">
                        Do you provide support after work done?
                    </div>
                    <div className="collapse-content">
                        <p tabIndex={3} className='text-lg'> Yes, I provide 2 week support after order completion/work done. If you need support for longer period like for month/year then get in touch with me and i will share my maintenance packages with you!</p>
                    </div>
                </div>

                <div tabIndex={4} className="collapse my-2 collapse-arrow border border-base-500 bg-base-100 ">
                    <div className="collapse-title text-xl font-medium">
                        Do you provide the licenses for LearnDash and other plugin that you used in website?


                    </div>
                    <div className="collapse-content">
                        <p tabIndex={4} className='text-lg'> No, I don't. If you will need to use any premium plugin then you might need to purchase it.</p>
                    </div>
                </div> */}
            </div>
        </div>
    );
};

export default Faq;